import { combineReducers } from 'redux';

import seatingplan from './seatingplanReducer';
import event from './eventReducer';
import venue from './venueReducer';
import merchant from './merchantReducer';
import eventPage from './eventPageReducer';
import shoppingCart from './shoppingCartReducer';
import bookingOffice from './bookingOfficeReducer';
import customer from './customerReducer';
import order from './orderReducer';
import layout from './layoutReducer';
import selectableSeats from './selectableSeatsReducer';
import selectedSeats from './selectedSeatsReducer';
import seatState from './seatStateReducer';
import checkoutPage from './checkoutPageReducer';
import categoryFilter from './categoryFilterReducer';
import purchaseSuccess from './purchaseSuccessReducer';
import file from './fileReducer';
import seatingplanPageReducer from './seatingplanPageReducer';
import ticketAddress from './ticketAddressReducer';
import payment from './paymentReducer';
import addon from './addonReducer';
import accessCodes from './accessCodesReducer';
import checkout from './checkoutProcessReducer';
import crossSelling from './crossSellingEventReducer';
import sponsorCodes from './sponsorCodeReducer';

const app = combineReducers({
	seatingplan,
	event,
	crossSelling,
	merchant,
	eventPage,
	venue,
	shoppingCart,
	bookingOffice,
	customer,
	order,
	layout,
	selectableSeats,
	selectedSeats,
	seatState,
	checkoutPage,
	categoryFilter,
	purchaseSuccess,
	file,
	seatingplanPageReducer,
	ticketAddress,
	payment,
	addon,
	accessCodes,
	checkout,
	sponsorCodes
});

export default app;
